import * as React from 'react';
import * as moment from 'moment';

import { connect, Dispatch } from 'react-redux';
import { ICalendarAppState } from '../redux-state';
import { applyPromoCode, removePromoCode } from '../redux-state/actions/calendar-api.actions';

import MonthSelectionDropdownView from 'month-selection-dropdown.view';
import { ICalendarAppText } from '../custom/classes/calendar-text';
import PromoCodeView from 'promo-code.view';
import { updatePromoCodeString, ShowPromoComponent } from '../redux-state/actions/promo-code.actions';
import { disconnect } from 'cluster';
import { IPromoCodeState, PromoCodeState } from '../classes/promo-code';
import CalendarApi from '../common/calendar-api';
import { CalendarDeviceMode } from '../classes/calendar';
import { findDOMNode } from 'react-dom';

import A11yDialog = require('a11y-dialog');

interface IPromoCodeExternalProps {
}

interface StateToProps {
    text: ICalendarAppText;
    show: boolean;
    showPromoResult: boolean;
    promoCode: string;
    deviceMode: CalendarDeviceMode;
    filtersAlwaysModal: boolean;
}

interface DispatchToProps {
    submitPromoCode: (evt) => void;
    removePromoCode: (evt) => void;
    updatePromoCodeString: (promoCode: string) => void;
    onClose: (hide: boolean) => void;
}

interface ModalControlMethods {
    showModal: () => void;
    hideModal: () => void;
}

export type PromoCodeProps = IPromoCodeExternalProps & StateToProps & DispatchToProps;
export type PromoCodeViewProps = PromoCodeProps & ModalControlMethods;

export class PromoCodeBase extends React.Component<PromoCodeProps, any> implements ModalControlMethods {
    private dialog;

    constructor(props: PromoCodeProps) {
        super(props);
    }

    initializeModal() {
        if (this.dialog) {
            this.dialog.create();
        } else {
            const element = findDOMNode(this);
            this.dialog = new A11yDialog(element);
        }
    }

    destroyModal() {
        if (this.dialog) {
            // Hide the dialog, then unbind all listeners and finally set to null.
            this.dialog.destroy();
        }
    }

    componentDidMount() {
        if (this.props.deviceMode === CalendarDeviceMode.MOBILE || this.props.filtersAlwaysModal) {
            this.initializeModal();
        }
    }

    componentDidUpdate(prevProps: PromoCodeProps) {
        if (!this.props.filtersAlwaysModal) {
            switch (this.props.deviceMode) {
                case CalendarDeviceMode.MOBILE: {
                    this.initializeModal();
                    break;
                }
                default: {
                    this.destroyModal();
                }
            }
        }
    }

    componentWillUnmount() {
        this.destroyModal();
    }

    showModal() {
        if (this.dialog) {
            this.dialog.show();
        }
    }

    hideModal() {
        if (this.dialog) {
            this.dialog.hide();
        }
    }
    render() {
        return (
            <PromoCodeView {...this.props} showModal={this.showModal.bind(this)} hideModal={this.hideModal.bind(this)} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IPromoCodeExternalProps): StateToProps {
    return {
        text: state.calendarText,
        show: state.promoCode.showPromo,
        showPromoResult: state.promoCode.promoApiResponse != null,
        promoCode: state.promoCode.appliedPromoCode,
        deviceMode: state.calendarSettings.calendarDeviceMode,
        filtersAlwaysModal: state.calendarSettings.filtersAlwaysModal
    }
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: PromoCodeProps): DispatchToProps {
    return {
        submitPromoCode: (evt: any) => {
            evt.preventDefault();
            dispatch(applyPromoCode() as any)
        },
        removePromoCode: (evt: any) => {
            evt.preventDefault();
            dispatch(removePromoCode() as any)
        },
        updatePromoCodeString: (promoCode: string) => dispatch(updatePromoCodeString(promoCode) as any),
        onClose: (show: boolean) => dispatch(ShowPromoComponent(show) as any)
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(PromoCodeBase);